import { Component, computed } from '@angular/core';

import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';

import { getPropsFrom } from '../../../../utils/xmlParser';

interface SectionEndItemProperties {
  style: string;
  parentSectionId: string;
  parentSectionAllowsCollapse: boolean;
}

@Component({
  selector: 'lfe-section-end-item-form',
  imports: [],
  templateUrl: './section-end-item-form.component.html',
  standalone: true,
  styleUrl: './section-end-item-form.component.css'
})
export class SectionEndItemFormComponent extends BaseItemComponent<SectionEndItemProperties> {
  properties: BaseItemProperties & SectionEndItemProperties = {
    ...DEFAULT_BASE_PROPERTIES,
    style: '',
    parentSectionId: '',
    parentSectionAllowsCollapse: false
  };

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `section_end_${this.currentId()}`);

  // For now, we'll assume it should show. Later this will check parent section state
  shouldShow = computed(() => this.properties.parentSectionAllowsCollapse);

  extractLocalProperties(xml: Element): BaseItemProperties & SectionEndItemProperties {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const style = props['Style'] || '';
    const activationRule = props['ActivationRule'] || '';

    // These will need to be set by the parent form component based on the section context
    const parentSectionId = props['ParentSectionId'] || '';
    const parentSectionAllowsCollapse = props['ParentSectionAllowsCollapse'] === 'true';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      style,
      parentSectionId,
      parentSectionAllowsCollapse,
      isGenericRepeatItem
    };
  }
}
